// extracted by mini-css-extract-plugin
export var arrow = "_cd-1";
export var content = "_cd-0";
export var highlighted = "_cd-2";